import { store } from '../store';
import { getCurrentEmployerPermissions } from '../selectors/employers';
import {
  getCurrentCase,
  getCurrentCasePatient,
  getEditingCase,
  getEditingCasePatient,
} from '../screens/cases/selector';
import {
  PERMISSION_VAL_VIEW_ONLY,
  PERMISSION_VAL_CAN_EDIT,
  PERSONAL_CASE_PERMISSIONS,
  FAMILY_MEMBER_PERMISSIONS,
  USERS_CASE_OVERRIDE_PERMISSIONS,
} from '../constants/permissions';

export function canView(permissions, key) {
  if (!permissions || !key) return false;

  if (!Array.isArray(key)) {
    const val = permissions[key];
    return val === PERMISSION_VAL_VIEW_ONLY || val === PERMISSION_VAL_CAN_EDIT;
  } else {
    for (const k of key) {
      const val = permissions[k];
      if (val === PERMISSION_VAL_VIEW_ONLY || val === PERMISSION_VAL_CAN_EDIT) {
        return true;
      }
    }
    return false;
  }
}

export function canEdit(permissions, key) {
  if (!permissions || !key) return false;

  if (!Array.isArray(key)) {
    const val = permissions[key];
    return val === PERMISSION_VAL_CAN_EDIT;
  } else {
    for (const k of key) {
      const val = permissions[k];
      if (val === PERMISSION_VAL_CAN_EDIT) {
        return true;
      }
    }
    return false;
  }
}

export function currentEmployerPermissions(key) {
  const permissions = getCurrentEmployerPermissions(store.getState());
  return {
    canView: canView(permissions, key),
    canEdit: canEdit(permissions, key),
  };
}

export function currentCasePermissions(key) {
  const employers = store.getState().entities.employers;
  const theCase = getCurrentCase(store.getState());
  const casePatient = getCurrentCasePatient(store.getState());
  const userProfile = store.getState().entities.userProfile;

  const permissions = permissionsForCase(employers, theCase, casePatient, userProfile);
  return {
    canView: canView(permissions, key),
    canEdit: canEdit(permissions, key),
  };
}

export function editingCasePermissions(key) {
  const employers = store.getState().entities.employers;
  const theCase = getEditingCase(store.getState());
  const casePatient = getEditingCasePatient(store.getState());
  const userProfile = store.getState().entities.userProfile;

  const permissions = permissionsForCase(employers, theCase, casePatient, userProfile);
  return {
    canView: canView(permissions, key),
    canEdit: canEdit(permissions, key),
  };
}

function permissionsForCase(employers, theCase, casePatient, userProfile) {
  if (!theCase) return null;

  // the case is not associated with an employer org
  if (!theCase?.employerId) {
    return _applyCurrentUserOverrides(PERSONAL_CASE_PERMISSIONS, casePatient, userProfile);
  }

  // if the case is associated with an employer org, but the user is not
  // on the staff (employer data is not in their userProfile)
  const employer = employers && employers[theCase.employerId];
  if (!employer || employer.external === true || employer.external === undefined) {
    return _applyCurrentUserOverrides(FAMILY_MEMBER_PERMISSIONS, casePatient, userProfile);
  }

  return _applyCurrentUserOverrides(employer.permissions, casePatient, userProfile);
  // return TEST_PERMISSIONS;
}

function _applyCurrentUserOverrides(perms, casePatient, userProfile) {
  if (!perms) return {};
  if (casePatient && userProfile && casePatient.userId === userProfile.userId) {
    const permOverrides = {};
    Object.keys(USERS_CASE_OVERRIDE_PERMISSIONS).forEach((k) => {
      // if the user doesnt have true permission then override with the override val
      // which is usually view only. If they have true set then dont override because this
      // means they already have edit permission for this perm
      permOverrides[k] = perms[k] || USERS_CASE_OVERRIDE_PERMISSIONS[k];
    });

    return {
      ...perms,
      ...permOverrides,
    };
  }
  return perms;
}
